<template>
  <section
    id="interview"
    class="co-bg-striped px-5 py-20"
  >
    <div class="co-container-sm">
      <h2 class="co-heading-2-caption">
        受講生インタビュー
      </h2>
      <div class="mb-12 text-center text-co-gray-600">
        テックアカデミーから目標を叶えた受講生
      </div>
      <div class="mb-7 flex flex-col gap-7 md:flex-row">
        <!-- hnさん -->
        <div class="w-full rounded-lg bg-co-gray-50">
          <div class="te-bg-interview-hn rounded-t-lg p-5">
            <div class="te-bg-interview-title rounded p-3">
              <h3 class="co-display-8 mb-1 font-bold text-co-primary-400">
                半年で30万円の報酬を獲得できるように
              </h3>
              <div class="co-display-13 text-co-gray-500">
                福祉の仕事を続けながら収入を増やしたいという想いから、プログラミングを学び副業で収入が得られるようになりました。
              </div>
            </div>
          </div>
          <div class="flex items-center gap-4 p-4">
            <img
              src="~/assets/images/Te/TeCourse/Ordermade/Interview/icon-hn.png"
              width="80"
              height="80"
              class="rounded-full"
              loading="lazy"
              alt="H.Nさん"
            >
            <div class="co-display-12 text-co-gray-600">
              20代 男性<br>H.Nさん 元介護施設スタッフ
            </div>
          </div>
        </div>
        <!-- 岩上さん -->
        <div class="w-full rounded-lg bg-co-gray-50">
          <div class="te-bg-interview-iwagami rounded-t-lg p-5">
            <div class="te-bg-interview-title rounded p-3">
              <h3 class="co-display-8 mb-1 font-bold text-co-primary-400">
                子育てしながらキャリチェンジに成功
              </h3>
              <div class="co-display-13 text-co-gray-500">
                子供が小学生になり時間が作れるようになったので、Webデザインを学び時給単価の高い仕事ができるようになりました。
              </div>
            </div>
          </div>
          <div class="flex items-center gap-4 p-4">
            <img
              src="~/assets/images/Te/TeCourse/Ordermade/Interview/icon-m-iwagami.png"
              width="80"
              height="80"
              class="rounded-full"
              loading="lazy"
              alt="岩神 美紀さん"
            >
            <div class="co-display-12 text-co-gray-600">
              40代 女性<br>岩神 美紀さん 元農家
            </div>
          </div>
        </div>
      </div>
      <div class="flex flex-col gap-7 md:flex-row">
        <!-- 垣内さん -->
        <div class="w-full rounded-lg bg-co-gray-50">
          <div class="te-bg-interview-kakiuchi rounded-t-lg p-5">
            <div class="te-bg-interview-title rounded p-3">
              <h3 class="co-display-8 mb-1 font-bold text-co-primary-400">
                Web制作会社の転職を経てフリーランスに転身
              </h3>
              <div class="co-display-13 text-co-gray-500">
                子供が小学生となり、自宅でできる仕事をしたいと考え受講しました。その後、Web制作企業に転職し、その後フリーランスに転身できるようになりました。
              </div>
            </div>
          </div>
          <div class="flex items-center gap-4 p-4">
            <img
              src="~/assets/images/Te/TeCourse/Ordermade/Interview/icon-kakiuchi.jpg"
              width="80"
              height="80"
              class="rounded-full"
              loading="lazy"
              alt="垣内 晴賀さん"
            >
            <div class="co-display-12 text-co-gray-600">
              30代 女性<br>垣内 晴賀さん 元保険会社の営業
            </div>
          </div>
        </div>
        <!-- 小坂さん -->
        <div class="w-full rounded-lg bg-co-gray-50">
          <div class="te-bg-interview-kosaka rounded-t-lg p-5">
            <div class="te-bg-interview-title rounded p-3">
              <h3 class="co-display-8 mb-1 font-bold text-co-primary-400">
                Webデザイナーとしてフリーランスに転身
              </h3>
              <div class="co-display-13 text-co-gray-500">
                事務職として働いていたが、0から考えて工夫するのが好きであることに気が付き、Webデザインを学びWeb制作フリーランスとして転身ができるようになりました。
              </div>
            </div>
          </div>
          <div class="flex items-center gap-4 p-4">
            <img
              src="~/assets/images/Te/TeCourse/Ordermade/Interview/icon-kosaka.png"
              width="80"
              height="80"
              class="rounded-full"
              loading="lazy"
              alt="小坂 香央里さん"
            >
            <div class="co-display-12 text-co-gray-600">
              30代 女性<br>小坂 香央里さん 元学校職員
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<style scoped>
.te-bg-interview-hn {
  background: linear-gradient(180deg, rgba(70, 215, 203, .9)0%, rgba(60, 170, 236, .9) 100%), url('~/assets/images/Te/TeCourse/Ordermade/Interview/bg-blog-hn.jpg');
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
}

.te-bg-interview-iwagami {
  background: linear-gradient(180deg, rgba(70, 215, 203, .9)0%, rgba(60, 170, 236, .9) 100%), url('~/assets/images/Te/TeCourse/Ordermade/Interview/bg-blog-k-iwagami.jpg');
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
}

.te-bg-interview-kakiuchi {
  background: linear-gradient(180deg, rgba(70, 215, 203, .9)0%, rgba(60, 170, 236, .9) 100%), url('~/assets/images/Te/TeCourse/Ordermade/Interview/bg-blog-kakiuchi.jpg');
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
}

.te-bg-interview-kosaka {
  background: linear-gradient(180deg, rgba(70, 215, 203, .9)0%, rgba(60, 170, 236, .9) 100%), url('~/assets/images/Te/TeCourse/Ordermade/Interview/bg-blog-k-kosaka.jpg');
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
}

.te-bg-interview-title {
  background: rgba(255, 255, 255, 0.9);
}
</style>
